export const FETCH_COMPANY_REQUEST = 'FETCH_COMPANY_REQUEST'
export const FETCH_COMPANY_SUCCES = 'FETCH_COMPANY_SUCCES'
export const FETCH_COMPANY_ERROR = 'FETCH_COMPANY_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Company.js